@if (queryView === 'TIMESERIES') {
  <app-time-series
    [queryId]="queryId"
    [view]="viewIndex"
    [myQueriesView]="myQueriesView"
    [parks]="parks$ | async"
    (updateQueriesList)="updateList()"
    (back)="back()">
  </app-time-series>
}
@if (queryView === 'SCATTER_PLOT') {
  <app-scatter-plot
    [queryId]="queryId"
    [view]="viewIndex"
    [myQueriesView]="myQueriesView"
    [parks]="parks$ | async"
    (updateQueriesList)="updateList()"
    (back)="back()">
  </app-scatter-plot>
}
@if (queryView === 'ALL_QUERIES_LIST') {
  <div>
    <div class="mb-4">
      @if (creatingQuery) {
        <lib-card>
          <lib-card-body>
            <app-loading-and-no-data-template
              [isLoading]="creatingQuery"
            ></app-loading-and-no-data-template>
          </lib-card-body>
        </lib-card>
      }
      @if (!creatingQuery) {
        <app-queries-list
          [title]="'DATA_STUDIO.DATA_ANALYSIS.MY_QUERIES'"
          [dataSource]="dataSource"
          [myQueriesView]="true"
          [total]="totalMyQueries"
          (changePageOptions)="changePageOptions($event)"
          (deleteDataAnalysisQuery)="deleteQuery($event)"
          (createQuery)="createQuery($event)"
          (changeView)="changeView($event)"
          (searchForTitle)="searchForTitle($event)"
        ></app-queries-list>
      }
    </div>
    <div>
      @if (creatingSharedQuery) {
        <lib-card>
          <lib-card-body>
            <app-loading-and-no-data-template
              [isLoading]="creatingSharedQuery"
            ></app-loading-and-no-data-template>
          </lib-card-body>
        </lib-card>
      }
      @if (!creatingSharedQuery) {
        <app-queries-list
          [title]="'DATA_STUDIO.DATA_ANALYSIS.SHARED_QUERIES'"
          [dataSource]="dataSourceShared"
          [myQueriesView]="false"
          [total]="totalSharedQueries"
          (changePageOptions)="changePageOptions($event)"
          (deleteDataAnalysisQuery)="deleteQuery($event)"
          (createQuery)="createQuery($event)"
          (changeView)="changeView($event)"
          (searchForTitle)="searchForTitle($event)"
        ></app-queries-list>
      }
    </div>
  </div>
}
